import { Component, Injectable, Input, OnChanges, OnDestroy } from '@angular/core';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

import { AlertService } from '../../../../../app/utils/alert.service';
import { ConsumptionReportService } from '../../../../../app/services/reports.consumption.service';
import { ReportsComponent } from '../../../../../app/home/paraEmpresas/reports/content.component';
import { ConsumptionReportView } from '../../../../../app/models/reports.consumption.view.model';
import { DataPackConsumptionReportView } from 'app/models/dataPackConsumptionReportView.model';
import { LoadingComponent } from "../../../../../app/home/paraEmpresas/modalLoading/content.component";
import { BindComponentService } from "../../../../../app/utils/bind.component.service";

import * as _ from "lodash";
import * as moment from 'moment';

/**
 * @version $Id: content.component.ts 93116 2018-06-04 20:15:20Z thiago.h.neri $
 */
@Component({
  selector: 'consumptionReport',
  templateUrl: './content.template.html'
})
@Injectable()
export class ConsumptionReportComponent implements OnChanges {

  private static readonly FETCH_SIZE: number = 50;

  public consolidateTraffics: Array<DataPackConsumptionReportView>;
  public consolidateCosts: Array<DataPackConsumptionReportView>;
  public consolidateMonetaryCosts: Array<DataPackConsumptionReportView>;

  public trafficsSelected: string ='';
  public costsSelected: string;
  public costPage: number  =ConsumptionReportComponent.FETCH_SIZE;;
  public trafficPage: number =ConsumptionReportComponent.FETCH_SIZE;
  public totalPage:number;
  public  isHibrid:boolean;
  public  isMonetary:boolean;

  @Input() reportTypeName: any;
  @Input() consumptionType: any;
  @Input() detailType: any;

  constructor(private bindComponent: BindComponentService,
    private modalService: NgbModal,
    private consumptionReportService: ConsumptionReportService,
    private alertService: AlertService) {
  }

  ngOnChanges() {
    this.consolidateTraffics=[];
    this.consolidateCosts=[];
    this.trafficsSelected=null;
    this.costsSelected=null;
    this.loadView();
  }

  private openModalLoading() {
    this.modalService.open(LoadingComponent, {
      backdrop: "static",
      keyboard: false
    });
  }

  private loadView() {
    this.openModalLoading();
    this.consumptionReportService.listConsumptions(this.reportTypeName.id, this.consumptionType.id, this.detailType.id, 1, ConsumptionReportComponent.FETCH_SIZE,null).subscribe(
      data => {
        this.trafficsSelected = null;
        this.setConsumption(data['consolidateTraffics'], data['consolidateCosts'], data['consolidateMonetaryCosts']);
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
        this.costPage++;
        this.trafficPage++;
        this.isHibrid = data['isHibrid'];
        this.isMonetary = data['isMonetary'];
      },
      err => {
        this.alertService.error(err.result, err);
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
      }
    );
  }

  private isCycleConsumption(): boolean {
    return this.reportTypeName.id === ReportsComponent.REPORT_TYPE_THREE_LAST_CYCLES;
  }

  private setConsumption(consolidateTraffics: Array<DataPackConsumptionReportView>, consolidateCosts: Array<DataPackConsumptionReportView>, consolidateMonetaryCosts: Array<DataPackConsumptionReportView>) {
    this.consolidateTraffics = consolidateTraffics;
    this.consolidateCosts = consolidateCosts;
    this.consolidateMonetaryCosts = consolidateMonetaryCosts;
  }

  private toggleTraffic(trafficsCycleId: string) {
    if(!this.trafficsSelected || this.trafficsSelected !== trafficsCycleId) {
      this.trafficsSelected = trafficsCycleId;
    } else {
      this.trafficsSelected = '';
    }
  }

  private toggleCosts(costsCycleId: string) {
    if(!this.costsSelected || this.costsSelected !== costsCycleId) {
      this.costsSelected = costsCycleId;
    } else {
      this.costsSelected = null;
    }
  }
  private downloadFile(){
    this.consumptionReportService.generateReport(this.reportTypeName.id, this.consumptionType.id, this.detailType.id, 1, 100000);
  }
  private maskMsisdn(msisdn: string): string {
    if(_.isNil(msisdn)) {
      return '';
    }
    if(msisdn.length == 12) {
      return '('.concat(msisdn.substr(0,3)).concat(') ').concat(msisdn.substring(3,(msisdn.length -4))).concat('-').concat(msisdn.substr(-4,4));
    } else if(msisdn.length == 11) {
      return '('.concat(msisdn.substr(0,2)).concat(') ').concat(msisdn.substring(2,(msisdn.length -4))).concat('-').concat(msisdn.substr(-4,4));
    }
    return msisdn;
  }

  private maskConsumptionVoiceMinute(consumption: string) : string {
    let vazio : string ='-';
    if (consumption === vazio) {
      return '00:00 Min';
    } else if (null != consumption) {
      return consumption;
    } else {
      return '00:00 Min';
    }
  }

  private showMoreCostReports(list:any) {
    this.openModalLoading();
    this.openModalLoading();
    this.consumptionReportService.listConsumptions(this.reportTypeName.id, this.consumptionType.id, this.detailType.id,1,this.costPage,list.initialCycle).subscribe(
      data => {
        if(data['consolidateCosts'].length >=1 && data['consolidateCosts'][0].report.length  === this.consolidateCosts[0].report.length){
          this.alertService.warn('Nenhum registro encontrado');
        }else if(data['consolidateCosts'].length <1) {
          this.alertService.warn('Nenhum registro encontrado');
        }else{
          this.costPage =  this.costPage +  ConsumptionReportComponent.FETCH_SIZE;
          this.addCost(data['consolidateCosts']);
        }
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
      },
      err => {
        this.alertService.error(err.result, err);
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
      }
    );
  }

  private showMoreTrafficReports(list:any) {
    this.openModalLoading();
    this.openModalLoading();
    this.consumptionReportService.listConsumptions(this.reportTypeName.id, this.consumptionType.id, this.detailType.id, 1,this.trafficPage,list.initialCycle).subscribe(
      data => {
        if (data['consolidateTraffics'].length >=1 && data['consolidateTraffics'][0].report.length  === this.consolidateTraffics[0].report.length){
          this.alertService.warn('Nenhum registro encontrado');
        }else if(data['consolidateTraffics'].length <1) {
          this.alertService.warn('Nenhum registro encontrado');
        }else{
          this.trafficPage =  this.trafficPage +  ConsumptionReportComponent.FETCH_SIZE;
          this.addTraffics(data['consolidateTraffics']);
        }
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
      },
      err => {
        this.alertService.error(err.result, err);
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
      }
    );
  }

  private addTraffics(consolidateTrafficsData:  Array<DataPackConsumptionReportView>) {
    if(consolidateTrafficsData.length >=1 &&
        this.consolidateTraffics[0].initialCycle == consolidateTrafficsData[0].initialCycle){
      this.consolidateTraffics[0].report = consolidateTrafficsData[0].report;
    }
   }

   private addCost(consolidateCostsData:  Array<DataPackConsumptionReportView>) {
    if(consolidateCostsData.length >=1 &&  this.consolidateCosts[0].initialCycle == consolidateCostsData[0].initialCycle){
      this.consolidateCosts[0].report = consolidateCostsData[0].report;
    }
   }

   private mouseEnter(htmlText: string ) {
     setTimeout(() => {
       document.getElementsByClassName("popover in popover-top")[0].classList.add("popover-rep");
       document.getElementsByClassName("popover-content")[0].innerHTML = htmlText;
       document.getElementsByClassName("popover-content")[0].classList.add("popover-big-rep");

     }, 15);
  }

  public openTooltip(adicionalPacksForPopOver:string):boolean{
    return adicionalPacksForPopOver!=undefined
  }

get filteredCosts() {
  return (this.consolidateMonetaryCosts || []).filter(
    c => Array.isArray(c.report) && c.report.length > 0
  );
}
}



// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/reports/consumption/content.component.ts